import * as React from "react";
import styled from "styled-components";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text";

interface SettingProps {
  description: string;
}

const Setting: React.ReactFCWithChildren<SettingProps> = ({ description, children }) => (
  <SettingWrapper direction="vertical">
    <Text>
      {description}
    </Text>

    <ContentWrapper>
      {children}
    </ContentWrapper>
  </SettingWrapper>
);

const SettingWrapper = styled(Grid.Bounds)`
  &:not(:first-of-type) {
    margin-top: 15px;
  }
`;

const ContentWrapper = styled.div`
  margin: 18px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default Setting;
